import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { MongoDbAtlasLinkedService } from 'app/model/linkedservice/mongo-db-atlas.linkedservice';
import { Constants } from 'app/shared/shared-constants';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { akvToModel, akvToResource } from './azure-key-vault.util';
import { ITridentResource } from 'shell-models-lib';
import { mongoDbDriverVersion } from 'app/shared/utils/connector-metadata-static-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MongoDbAtlasLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                connectionString: 'secret',
                database: '*',
                driverVersion: '*',
                encryptedCredential: '*'
            }
        }
    }
})

export class MongoDbAtlasLinkedServiceAdapter extends LinkedServiceAdapter<MongoDbAtlasLinkedService> {
    protected supportFirstClassParameterExperience = false;

    protected override toAzureTypeProperties = (tridentResource: ITridentResource): Partial<Model.MongoDbAtlasLinkedServiceTypeProperties> => {
        try {
            const connectionDetails = JSON.parse(tridentResource.connectionDetails);
            const extensionDataSourcePath = JSON.parse(connectionDetails.extensionDataSourcePath);
            return {
                connectionString: extensionDataSourcePath.server,
                driverVersion: mongoDbDriverVersion.V2
            }

        } catch (e) {
            return {};
        }
    };

    protected modelConstructor(): new () => MongoDbAtlasLinkedService {
        return MongoDbAtlasLinkedService;
    }

    protected model(): IModel {
        return MongoDbAtlasLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: MongoDbAtlasLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.MongoDbAtlasLinkedService;
        properties.type = Metamodel.modelFor(MongoDbAtlasLinkedService).name;
        let connectionString: string | Model.SecretBase = linkedService.connectionString;
        connectionString = !linkedService.enableAKV ?
            this._connectionStringToResource(connectionString) : akvToResource(linkedService.referedAKV, this.context);
        if (linkedService != null) {
            properties.typeProperties = {
                connectionString,
                database: linkedService.databaseName,
                driverVersion: linkedService.driverVersion
            };
        }

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: MongoDbAtlasLinkedService): Promise<MongoDbAtlasLinkedService> {
        const properties = linkedServiceResource.properties as Model.MongoDbAtlasLinkedService;
        linkedService.connectionString = undefined;
        linkedService.databaseName = undefined;
        linkedService.driverVersion = undefined;
        linkedService.enableAKV = false;
        linkedService.referedAKV = undefined;

        if (properties.typeProperties.connectionString
            && (properties.typeProperties.connectionString as Model.SecretBase).type === 'AzureKeyVaultSecret') {
            linkedService.referedAKV = akvToModel(properties.typeProperties.connectionString as Model.AzureKeyVaultSecretReference, this.context);
            linkedService.enableAKV = true;
        } else {
            if (properties.typeProperties.connectionString != null) {
                linkedService.connectionString = Constants.maskedCredential;
            }
        }

        linkedService.databaseName = properties.typeProperties.database;

        if (properties.typeProperties.driverVersion != null) {
            linkedService.driverVersion = properties.typeProperties.driverVersion;
        }

        return linkedService;
    }
}
